import { render, staticRenderFns } from "./CustomerTasks.vue?vue&type=template&id=bbed864a&scoped=true&"
import script from "./CustomerTasks.vue?vue&type=script&lang=js&"
export * from "./CustomerTasks.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTasks.vue?vue&type=style&index=0&id=bbed864a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbed864a",
  null
  
)

export default component.exports